/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors } from '../../shared/theme/ticketColors';

type CatalogListSkeletonProps = {
  rows?: number;
};

/** Placeholder rows para el primer load del catálogo (no en refresh). */
export function CatalogListSkeleton({ rows = 5 }: CatalogListSkeletonProps) {
  return (
    <View style={styles.container}>
      {Array.from({ length: rows }, (_, i) => (
        <View key={i} style={styles.row}>
          <View style={styles.titleBar} />
          <View style={styles.metaBar} />
          <View style={styles.valueBar} />
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.sm,
    padding: spacing.md,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
  },
  titleBar: {
    flex: 1,
    height: 16,
    borderRadius: 4,
    backgroundColor: ticketColors.paper2,
  },
  metaBar: {
    width: 80,
    height: 12,
    borderRadius: 4,
    backgroundColor: ticketColors.paper2,
  },
  valueBar: {
    width: 60,
    height: 16,
    borderRadius: 4,
    backgroundColor: ticketColors.paper2,
  },
});
